import React from 'react';
import { produce } from 'immer';

import { InsertionLayoutFeatureArea } from '../../../../../../store/slices/applicationSlice';
import { LayoutRectangleControls } from '../../../../../controls/layout-shapes/LayoutRectangleControls';

interface Props {
  value: InsertionLayoutFeatureArea;
  disabled?: boolean;
  onChange: (value: InsertionLayoutFeatureArea) => void;
}

export function FeatureAreaRectangleControls({ value, disabled, onChange }: Props) {
  return (
    <LayoutRectangleControls
      value={value.area}
      disabled={disabled}
      positionTarget="feature-position"
      onChange={(area) => {
        onChange(
          produce(value, (draft) => {
            Object.assign(draft.area, area);
          }),
        );
      }}
    />
  );
}
